/*
  Sola Studio — cart drawer.

  Nothing here is Dawn's: the drawer is opened by any add-to-cart form on the
  site, so a section only has to ship a normal {% form 'product' %} to take part.

  Coupons: /discount/CODE is what actually applies a code, and /cart.js is the
  only place that says whether it stuck — cart.discount_codes carries
  { code, applicable }. Codes pile up in that list, so a new one is only applied
  after clearing the old with /cart/update.js { discount: '' }, which is also the
  one endpoint that removes a code.
*/
(function () {
  'use strict';

  var SECTION = 'sola-cart-drawer';
  var OPEN_CLASS = 'sola-cart-open';
  var lastFocus = null;
  var busy = false;

  function root() { return document.querySelector('[data-sola-cart-drawer]'); }
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function setCount(n) {
    document.querySelectorAll('[data-sola-cart-count]').forEach(function (e) {
      e.textContent = n;
      /* the badge over the icon hides itself when the cart empties */
      e.classList.toggle('is-empty', !n);
    });
  }

  function setStatus(msg, kind) {
    var box = root() && root().querySelector('[data-sola-cart-status]');
    if (!box) return;
    box.textContent = msg || '';
    box.setAttribute('data-kind', kind || '');
    box.hidden = !msg;
  }

  function setLoading(on) {
    busy = !!on;
    var r = root();
    if (r) r.classList.toggle('is-loading', busy);
  }

  function getCart() {
    return fetch(rootUrl() + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  /* Re-renders the drawer from Liquid so prices, discounts and money format
     always come from Shopify instead of being rebuilt here. */
  function refresh() {
    return fetch(rootUrl() + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION];
        var r = root();
        if (!html || !r) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sola-cart-content]');
        var current = r.querySelector('[data-sola-cart-content]');
        if (fresh && current) current.replaceWith(fresh);
      })
      .then(getCart)
      .then(function (cart) { setCount(cart.item_count); return cart; });
  }

  function open() {
    var r = root();
    if (!r) return;
    lastFocus = document.activeElement;
    r.setAttribute('data-open', 'true');
    document.documentElement.classList.add(OPEN_CLASS);
    var focusable = r.querySelector('[data-sola-cart-close]');
    if (focusable) focusable.focus();
  }

  function close() {
    var r = root();
    if (!r) return;
    r.removeAttribute('data-open');
    document.documentElement.classList.remove(OPEN_CLASS);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ------------------------------------------------------------- carrinho -- */

  function changeLine(key, qty) {
    if (busy) return;
    setLoading(true);
    setStatus('');
    fetch(rootUrl() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function () { return refresh(); })
      .catch(function () { setStatus(msg('erro'), 'erro'); })
      .then(function () { setLoading(false); });
  }

  function msg(name) {
    var r = root();
    return (r && r.getAttribute('data-msg-' + name)) || '';
  }

  /* --------------------------------------------------------------- cupons -- */

  function applyCoupon(code) {
    if (busy) return;
    code = (code || '').trim();
    if (!code) { setStatus(msg('vazio'), 'erro'); return; }
    setLoading(true);
    setStatus(msg('checando'), '');

    /* limpa antes: os codigos se acumulam e o carrinho ficaria com dois */
    fetch(rootUrl() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: '' })
    })
      .then(function () {
        return fetch(rootUrl() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
      })
      .then(getCart)
      .then(function (cart) {
        var found = (cart.discount_codes || []).filter(function (d) {
          return d.code.toLowerCase() === code.toLowerCase();
        })[0];
        /* Um codigo que nao existe e um que existe mas nao vale voltam iguais:
           o Shopify registra os dois com applicable: false. Nao da para separar
           os dois casos daqui, entao o aviso e um so. */
        if (found && found.applicable) return finish('', '');
        /* tira o codigo recusado para nao viajar junto ate o checkout */
        return fetch(rootUrl() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: '' })
        }).then(function () { return finish(msg('naoaplicavel'), 'erro'); });
      })
      .catch(function () { finish(msg('erro'), 'erro'); });
  }

  function removeCoupon() {
    if (busy) return;
    setLoading(true);
    fetch(rootUrl() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: '' })
    })
      .then(function () { return finish('', ''); })
      .catch(function () { finish(msg('erro'), 'erro'); });
  }

  function finish(text, kind) {
    return refresh().then(function () {
      setLoading(false);
      setStatus(text, kind);
    });
  }

  /* ------------------------------------------------------------- eventos -- */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form || !root()) return;
    e.preventDefault();
    if (busy) return;
    setLoading(true);
    setStatus('');
    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      })
      .then(function (res) {
        if (!res.ok) {
          setLoading(false);
          setStatus(res.body.description || res.body.message || msg('erro'), 'erro');
          open();
          return;
        }
        return refresh().then(function () { setLoading(false); open(); });
      })
      .catch(function () { setLoading(false); setStatus(msg('erro'), 'erro'); });
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('[data-sola-cart-close]') || t.closest('[data-sola-cart-overlay]')) {
      e.preventDefault();
      close();
      return;
    }

    /* qualquer caminho para a sacola abre a gaveta */
    var toCart = t.closest('[data-sola-cart-open], #cart-icon-bubble, a[href$="/cart"]');
    if (toCart && root()) {
      e.preventDefault();
      open();
      return;
    }

    var step = t.closest('[data-sola-qty]');
    if (step) {
      e.preventDefault();
      changeLine(step.getAttribute('data-key'), Number(step.getAttribute('data-qty')));
      return;
    }

    var rm = t.closest('[data-sola-remove]');
    if (rm) {
      e.preventDefault();
      changeLine(rm.getAttribute('data-key'), 0);
      return;
    }

    if (t.closest('[data-sola-coupon-apply]')) {
      e.preventDefault();
      var input = root() && root().querySelector('[data-sola-coupon-input]');
      applyCoupon(input && input.value);
      return;
    }

    if (t.closest('[data-sola-coupon-remove]')) {
      e.preventDefault();
      removeCoupon();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      var input = e.target.closest && e.target.closest('[data-sola-coupon-input]');
      if (input) {
        e.preventDefault();
        applyCoupon(input.value);
        return;
      }
    }
    if (e.key === 'Escape') {
      var r = root();
      if (r && r.getAttribute('data-open')) close();
    }
  });

  window.solaCart = { open: open, close: close, refresh: refresh };
})();
